import * as React from "react";

import { getComponentEditorData } from "@v1/components/editor/componentTypes";
import {
  selectDraftComponentIds,
  selectDraftComponentType,
} from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";
import { Info } from "lucide-react";

const DraftComponentPaneHeader = () => {
  const draftComponentIds = useEditorSelector(selectDraftComponentIds);
  const draftComponentType = useEditorSelector(selectDraftComponentType);
  const draftComponentEditorData = getComponentEditorData(
    draftComponentType ?? "",
  );

  if (draftComponentIds.length === 1 && !draftComponentEditorData) {
    return null;
  }

  return (
    <div className="flex flex-row items-center justify-between pt-1">
      <span className="text-xs font-bold">
        {draftComponentIds.length > 1
          ? `${draftComponentIds.length} Items Selected`
          : draftComponentEditorData?.defaultName}
      </span>
      {draftComponentIds.length === 1 &&
        draftComponentEditorData?.documentationLink && (
          <a
            href={draftComponentEditorData.documentationLink}
            className="text-primary flex cursor-pointer items-center text-xs"
            target="_blank"
            rel="noreferrer"
          >
            Learn More <Info size={12} aria-hidden className="ml-1" />
          </a>
        )}
    </div>
  );
};

export default DraftComponentPaneHeader;
